import FigmaImg1 from '@assets/images/figma_export/image-1.png'
import FigmaImg2 from '@assets/images/figma_export/image-2.png'
import { FigmaLink } from '@components/App/Modal/ExportAsFigma/components/FigmaLink'
import { Modal } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import {
  Clone,
  FigmaFileLogo,
  FigmaLogo,
} from '@octopus-do/octopus-storybook/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import 'react-alice-carousel/lib/alice-carousel.css'

import AliceCarousel from 'react-alice-carousel'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { GlobalActions } from '@/store'
import type { ModalProps } from '@/types'
import { DotsItemComponent, NavButton } from './components'
import css from './styles.module.css'

export const ExportAsFigma: React.FC<ModalProps> = ({ onClose, onBack }) => {
  const dispatch = useDispatch()

  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const url = `${window.location.origin}/${projectId}`

  const onClickCopy = async () => {
    sendGtmEvent(GtmTriggerName.EXPORT_FIGMA, 'Click on copy icon')

    dispatch(GlobalActions.copy({ value: url }))
  }

  return (
    <Modal
      width={384}
      classnames={{ content: css.container }}
      onClose={onClose}
      onBack={onBack}
    >
      <div className={css.title}>Export to Figma</div>

      <div className={css.content}>
        <div className={css.carousel_wrapper}>
          <AliceCarousel
            items={[
              <img
                key="figma-1"
                src={FigmaImg1}
                className={css.image}
                alt=""
              />,
              <img
                key="figma-2"
                src={FigmaImg2}
                className={css.image}
                alt=""
              />,
            ]}
            infinite
            renderDotsItem={DotsItemComponent}
            renderPrevButton={NavButton}
            renderNextButton={NavButton}
          />
        </div>

        <div className={css.description}>
          Make the most of Octopus and Figma — generate high-fidelity wireframes
          or visual sitemaps.
        </div>

        <div className={css.divider} />

        <FigmaLink
          Icon={FigmaLogo}
          url="https://www.figma.com/community/plugin/1364110243223652066/octopus-do-to-figma"
          label="Octopus plugin"
          description="Install the plugin in your Figma project and copy the sitemap link to
          import."
        />

        <div className={css.form}>
          <input value={url} type="text" className={css.input} />

          <Button
            className={css.button}
            left={Clone}
            aria-label="Copy link"
            onClick={onClickCopy}
          />
        </div>

        <div className={css.divider} />

        <FigmaLink
          Icon={FigmaFileLogo}
          url="https://www.figma.com/community/file/1631648611405960961"
          label="Octopus Wireframes Kit"
          description="Use this kit along with the Octopus Figma plugin to generate
          high-fidelity wireframes."
        />
      </div>
    </Modal>
  )
}
